import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        console.error('Service worker registration failed:', err);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode temporarily disabled to fix PostHog analytics conflict
  // with React 19 double-rendering causing removeChild errors during file uploads
  <App />
);
